var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('nav-menu'),_c('div',{staticClass:"home-index"},[_c('router-view')],1),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }